import React from 'react';
import {bool} from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';

AppHeader.propTypes = {
    isOpen: bool.isRequired,
};

export default function AppHeader({isOpen}:any) {
    const appVersion = `Version ${process.env.REACT_APP_VERSION}`;
    
    return (
        <AppBar
            position="fixed"
            className={classNames('app-bar', {
                shifted: isOpen,
            })}
        >
            <Toolbar>
                <Typography
                    className="version"
                >
                    {appVersion}
                </Typography>
            </Toolbar>
        </AppBar>
    );
}

